var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPromos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 21.85"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-promos_svg__Icon_-_Promotions",
    "data-name": "Icon - Promotions",
    transform: "translate(.75 .75)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-promos_svg__Path_4018",
    "data-name": "Path 4018",
    d: "M7.827 14.9H5.173a4.423 4.423 0 010-8.846h2.654z",
    transform: "translate(-.75 -.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-promos_svg__Path_4019",
    "data-name": "Path 4019",
    d: "M7.827 14.9a26.3 26.3 0 0114.586 4.42l1.337.892V.75l-1.337.892A26.31 26.31 0 017.827 6.058z",
    transform: "translate(-.75 -.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-promos_svg__Path_4020",
    "data-name": "Path 4020",
    d: "M7.827 14.9a8.535 8.535 0 002.654 6.2",
    transform: "translate(-.75 -.75)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC41IDIxLjg1Ij4KICA8ZyBpZD0iSWNvbl8tX1Byb21vdGlvbnMiIGRhdGEtbmFtZT0iSWNvbiAtIFByb21vdGlvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzUgMC43NSkiPgogICAgPHBhdGggaWQ9IlBhdGhfNDAxOCIgZGF0YS1uYW1lPSJQYXRoIDQwMTgiIGQ9Ik03LjgyNywxNC45SDUuMTczYTQuNDIzLDQuNDIzLDAsMCwxLDAtOC44NDZINy44MjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC43NSAtMC43NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF80MDE5IiBkYXRhLW5hbWU9IlBhdGggNDAxOSIgZD0iTTcuODI3LDE0LjlBMjYuMywyNi4zLDAsMCwxLDIyLjQxMywxOS4zMmwxLjMzNy44OTJWLjc1bC0xLjMzNy44OTJBMjYuMzEsMjYuMzEsMCwwLDEsNy44MjcsNi4wNThaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC43NSAtMC43NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF80MDIwIiBkYXRhLW5hbWU9IlBhdGggNDAyMCIgZD0iTTcuODI3LDE0LjlBOC41MzUsOC41MzUsMCwwLDAsMTAuNDgxLDIxLjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjc1IC0wLjc1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconPromos as ReactComponent };